<template>
  <div class="related" v-if="relateData && relateData.length">
    <div class="related-title">
      <div class="related-title-text">{{ title }}</div>
    </div>
    <div class="related-list">
      <ul>
        <li class="global_pointer" v-for="item in relateData" :key="item.id" @click="jump(item)">
          <img v-if="type === 2" :src="item.logo.url" alt="">
          <img v-else :src="item.headImg.url" alt="">
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        title: String,
        relateData: Array,
        type: Number
    },
    data() {
        return {}
    },
    methods: {
        jump(item) {
            if (this.type === 1) {
                this.$router.push({
                    path: '/anchor',
                    query: {
                        hostId: item.id
                    }
                })
            } else {
                this.$router.push({
                        path: '/store',
                        query: {
                            storeId: item.id,
                        },
                    })
            }
        }
    }
}
</script>
<style lang="less" scoped>
.related{
  background: #1d1d1d;
}
.related-title{
  height: 24px;
  text-align: center;
  .related-title-text{
    display: inline-block;
    position: relative;
    border: 0.5px solid rgba(255,255,255, 0.1);
    color: #999999;
    font-size: 12px;
    padding: 6px 8px;
    border-radius: 16px;
    vertical-align: top;
    font-family: "TradeGothicLT";
    &:before{
      position: absolute;
      content: '';
      height: 0;
      width: 50px;
      border-bottom: 0.5px solid rgba(255,255,255, 0.1);
      left: -51px;
      top: 50%;
    }
    &:after{
      position: absolute;
      content: '';
      height: 0;
      width: 50px;
      border-bottom: 0.5px solid rgba(255,255,255, 0.1);
      right: -51px;
      top: 50%;
    }
  }
}
.related-list{
  overflow-x: scroll;
  overflow-y: hidden;
  overscroll-behavior-y: none;
  -webkit-overflow-scrolling:touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  margin: 16px 0 0;
  height: 38px;
  ul{
    white-space: nowrap;
    text-align: center;
    height: 38px;
    line-height: 38px;
  }
  li{
    display: inline-block;
    width: 38px;
    height: 38px;
    border-radius: 50%;
    overflow: hidden;
    flex-shrink: 0;
    margin: 0 6px;
    img{
      width: 100%;
    }
  }
}
</style>